// extracted by mini-css-extract-plugin
module.exports = {"header":"r_t g_k","logo":"r_v"};